import { createLocale } from "./createLocale";

export const sv = createLocale({
  header: {
    title: "Gå globalt. 2 $ per Short. Vilket språk som helst!",
    subtitle: "🔥Betala bara för resultat – från $0.089 till $0.009 per sekund🔥",
  },
  steps: {
    uploadVideo: "Ladda upp video",
    selectLanguages: "Välj språk",
    conversionResult: "Konvertering och resultat",
  },
  upload: {
    dragAndDrop: "Dra och släpp din videofil här",
    orClickToSelect: "eller klicka för att välja",
    supportedFormats: "Format som stöds: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Maximal filstorlek: 200 MB",
    maxDuration: "• Maximal längd: 30 sek",
    chooseFile: "Välj fil",
    selectedFile: "Vald fil:",
    size: "Storlek:",
    fileTypeError: "Välj en videofil",
    fileSizeError: "Filstorleken ({size} MB) överskrider maxgränsen på 200 MB",
    durationError: "Videolängden ({duration} sek) överskrider maxgränsen på 30 sek",
    fileReadError: "Det går inte att läsa videofilen. Försök med en annan fil.",
  },
  languages: {
    sourceAudioLanguage: "Källjudets språk",
    targetAudioLanguage: "Måljudets språk",
    selectLanguage: "Välj språk...",
  },
  conversion: {
    replaceAudio: "Klona min röst",
    uploadVideoAndSelectLanguages: "Ladda upp en video och välj språk för att fortsätta",
  },
  nav: {
    blog: "Blogg",
  },
  footer: {
    privacyPolicy: "Integritetspolicy",
    termsOfUse: "Användarvillkor",
  },
  languageOptions: {
    sv: "Svenska",
  },
});
